import { ILight } from './types';
import { OperatorPanelWrapper } from '../../components/Layout';
import { ButtonPanel } from './ButtonPanel';



export const OperatorPanel = (props: ILight) => {

    return (
        <>
            <OperatorPanelWrapper
                objectId={props.id}
                resourceGroupId={props.resourceGroupId}
                statusContent={<ButtonPanel {...props}></ButtonPanel>}            
                >
            </OperatorPanelWrapper>

        </>
    )
}
